import FormattedDate from '../../assets/elements/formatted-date'
import RenovatedImage from '../../../images/renovated.png'
const RenovationTag = ({rdate,customClass}) => {
  return (
    <div className={`renovation-date-tag ${customClass}`}><img src={RenovatedImage} alt="renovated-image" width={24} height={22}/> <FormattedDate fdate={rdate}/></div>
  )
}

export default RenovationTag